export default "__VITE_PUBLIC_ASSET__54290d78__"